module.exports = __webpack_public_path__ + "media/images/guideline/G_02-531cacaccaa77ebc1207ea9feac0237b.jpg";